var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcHide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-hide",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.836,
    height: 20.252,
    viewBox: "0 0 19.836 20.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    d: "M19.836,0H0V20.252H19.836Zm0,0H0V20.252H19.836Zm0,0H0V20.252H19.836Zm0,0H0V20.252H19.836Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    d: "M10.066,6.375a4.211,4.211,0,0,0-3.828,5.763L3.829,14.6A9.966,9.966,0,0,1,1,10.595a9.763,9.763,0,0,1,9.074-6.329,9.413,9.413,0,0,1,3.283.591L11.575,6.679A3.925,3.925,0,0,0,10.066,6.375Zm8.249-2.3L16.434,6l-.379.388a9.944,9.944,0,0,1,3.085,4.211,9.763,9.763,0,0,1-9.074,6.329,9.523,9.523,0,0,1-3.613-.709l-.346.354L3.689,19.033,2.642,17.961,17.267,3ZM13.753,8.738l-1.279,1.308a2.433,2.433,0,0,1,.066.548,2.5,2.5,0,0,1-2.475,2.532,2.278,2.278,0,0,1-.536-.068L8.251,14.367a4.015,4.015,0,0,0,1.815.447,4.174,4.174,0,0,0,4.125-4.219A4.261,4.261,0,0,0,13.753,8.738ZM10.2,8.08,7.6,10.738,7.583,10.6a2.5,2.5,0,0,1,2.475-2.532Z",
    transform: "translate(-0.148 -0.468)",
    fill: "#8b9095"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHide);
export default __webpack_public_path__ + "static/media/ic-hide.ba8631c3.svg";
export { ForwardRef as ReactComponent };